import { Check } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { prefillMotivo } from "../config/site";

const situations = [
  "Le cuesta concentrarse o mantener la atención.",
  "Tiene dificultades para leer, escribir o estudiar.",
  "Le cuesta organizarse y planificar las tareas.",
  "Dedica mucho tiempo al estudio y obtiene resultados inferiores a los esperados.",
  "Necesita orientación para decidir qué estudiar.",
  "La familia necesita comprender cómo ayudarle.",
];

export default function Help() {
  return (
    <section id="a-quien-ayudamos" data-testid="help-section" className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <SectionHeading
              eyebrow="¿A quién podemos ayudar?"
              title="Quizás te reconozcas en alguna de estas situaciones"
              intro="Detrás de cada dificultad hay una persona que aprende a su manera. No se trata de etiquetas ni de culpas: se trata de comprender qué necesita y acompañarle."
            />
            <Reveal delay={0.2}>
              <button
                onClick={() => prefillMotivo("Hola Lidia, me reconozco en alguna de las situaciones que describís en la web y me gustaría contaros nuestro caso.")}
                data-testid="help-cta-button"
                className="mt-8 inline-flex items-center gap-2 bg-sage hover:bg-sage-dark text-white font-accent font-semibold text-sm px-7 py-3.5 rounded-full transition-all duration-200 hover:-translate-y-0.5 shadow-sm hover:shadow-md cursor-pointer"
              >
                Contar nuestra situación
              </button>
            </Reveal>
          </div>

          <div className="lg:col-span-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {situations.map((s, i) => (
                <Reveal key={s} delay={(i % 2) * 0.08 + Math.floor(i / 2) * 0.06}>
                  <div
                    data-testid={`help-situation-${i}`}
                    className="flex items-start gap-4 bg-ivory border border-atento-blue/8 rounded-2xl p-6 hover:border-sage/40 hover:bg-sage-light/40 transition-all duration-300 h-full"
                  >
                    <span className="shrink-0 w-8 h-8 rounded-full bg-sage/15 flex items-center justify-center mt-0.5">
                      <Check className="w-4 h-4 text-sage-dark" strokeWidth={2.5} />
                    </span>
                    <p className="text-sm sm:text-base leading-relaxed text-charcoal/80">{s}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
